/**
 * API Configuration for Multi-AI Chatbot Frontend
 * Manages all backend endpoint URLs.
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
// API Endpoints
export const API_ENDPOINTS = {
  // Base API path
  BASE: `${API_BASE_URL}/api`,
  
  // Chat functionality
  CHAT: '/api/chat',
  
  // Model information
  MODELS: '/api/models',
  
  // Health check
  HEALTH: '/health',
  
  // ============================================
  // Document Upload (IMPLEMENTED)
  // ============================================
  UPLOAD: '/api/upload',

  // ============================================
  // Speech-to-Text / Whisper Fallback
  // ============================================
  TRANSCRIBE: '/api/transcribe',
  
  // ============================================
  // Conversation Management (IMPLEMENTED - Phase 2)
  // ============================================
  CONVERSATIONS: {
    LIST: '/api/conversations',
    CREATE: '/api/conversations',
    GET: (conversationId) => `/api/conversations/${conversationId}`,
    UPDATE: (conversationId) => `/api/conversations/${conversationId}`,
    DELETE: (conversationId) => `/api/conversations/${conversationId}`,
    ARCHIVE: (conversationId) => `/api/conversations/${conversationId}/archive`,
    UNARCHIVE: (conversationId) => `/api/conversations/${conversationId}/unarchive`,
    MESSAGES: (conversationId) => `/api/conversations/${conversationId}/messages`,
  }
};

// Model display configuration
export const MODEL_CONFIG = {
  'llama-4-maverick': {
    displayName: 'Llama 4 Maverick',
    color: '#FF6B35',
    icon: '',
    description: 'Fast and efficient',
    tooltip: 'Great for quick questions, code lookups, and short drafts.',
    status: 'active'
  },
  'claude-sonnet-4-5': {
    displayName: 'Claude Sonnet 4.5',
    color: '#D97757',
    icon: '',
    description: 'Advanced reasoning (Preview)',
    tooltip: 'Work in progress — coming soon.',
    status: 'wip'
  },
  'gpt-4o': {
    displayName: 'GPT-4o',
    color: '#10A37F',
    icon: '',
    description: 'Fast and capable',
    tooltip: 'Great for RFIs, document Q&A, equipment selection, and summaries.',
    status: 'active'
  },
  'gpt-5.1': {
    displayName: 'GPT-5.1',
    color: '#3B82F6',
    icon: '',
    description: 'Latest and most capable',
    tooltip: 'Great for complex design problems, load calcs, and feasibility studies.',
    status: 'active'
  },
  'gpt-5.5': {
    displayName: 'GPT-5.5',
    color: '#6366F1',
    icon: '',
    description: 'OpenAI GPT-5.5 - Azure AI Foundry',
    tooltip: 'Great for large documents, multi-discipline reports, and project-wide tasks.',
    status: 'active'
  }
};

// Engineering Service — upload/list/delete endpoints
// REACT_APP_ENG_SERVICE_URL must be set in .env.production (Azure Static Web App config).
// Fallback is localhost:8001 for local development only — it will not work in production
// if the env var is missing, which is intentional (fast failure rather than silent wrong calls).
export const ENG_SERVICE_URL = process.env.REACT_APP_ENG_SERVICE_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8001');
export const ENG_API_KEY = process.env.REACT_APP_ENG_API_KEY || '';
